import { Tabs } from 'antd';
import ExpenseConfigContainer from './ExpenseConfigContainer';
import TaxInvoiceAccountConfigContainer from './TaxInvoiceAccountConfigContainer';
import VendorConfig2Container from './VendorConfig2Container';
import ProjectConfigContainer from './ProjectConfigContainer';
import ApprovalConfigContainer from './ApprovalConfigContainer';

interface MyEnterpriseConfigContainerProps {
  enterpriseId: string;
}

function MyEnterpriseConfigContainer({
  enterpriseId,
}: MyEnterpriseConfigContainerProps) {
  const onChange = (key: string) => {
    console.log(key);
  };

  return (
    <>
      <Tabs
        defaultActiveKey="0"
        onChange={onChange}
        tabPosition={'left'}
        destroyInactiveTabPane
        items={[
          {
            label: `비용관리`,
            key: '0',
            children: (
              <>
                <ExpenseConfigContainer enterpriseId={enterpriseId} />
              </>
            ),
          },
          {
            label: `거래처 관리`,
            key: '1',
            children: <VendorConfig2Container enterpriseId={enterpriseId} />,
          },
          {
            label: `프로젝트 관리`,
            key: '2',
            children: <ProjectConfigContainer enterpriseId={enterpriseId} />,
          },
          {
            label: `전자결재`,
            key: '3',
            children: <ApprovalConfigContainer enterpriseId={enterpriseId} />,
          },
          {
            label: `홈택스연동`,
            key: '4',
            children: (
              <>
                <TaxInvoiceAccountConfigContainer enterpriseId={enterpriseId} />
              </>
            ),
          },
        ]}
      />
    </>
  );
}

export default MyEnterpriseConfigContainer;
